import { FoxMediaLink } from "@/pages/profile/constant/fox-meda-link";

const FOX_MEDIA_ORDER = [
  FoxMediaLink.Linkedin,
  FoxMediaLink.Instagram,
  FoxMediaLink.Facebook,
  FoxMediaLink.X,
  FoxMediaLink.Youtube,
];

export function getFoxMediaLinkList(data: any[] = []) {
  return FOX_MEDIA_ORDER.map((type) => {
    return data.find((item) => item.type === type) || { type };
  });
}
